import { useQuery } from "@tanstack/react-query";
import { fetchNextApiMatch, getManualMatch } from "../services/match";
import { NextMatchInfo } from "../types/Match";
import { MatchDaySettings } from "../types/Settings";
import { QUERY_CONSTANTS } from "../constants/query-constants";
import { useCookieConsent } from "../contexts/CookieConsentContext";

export const useNextMatch = (settings: MatchDaySettings) => {
    const { hasConsented } = useCookieConsent();

    return useQuery<NextMatchInfo | null>({
        queryKey: ["nextMatch", hasConsented, settings],
        queryFn: async () =>
            settings.source === "manual"
                ? getManualMatch(settings)
                : fetchNextApiMatch(settings),
        staleTime: QUERY_CONSTANTS.STALE_TIME,
        refetchInterval: QUERY_CONSTANTS.REFETCH_INTERVAL,
        enabled: hasConsented && settings.show,
    });
};
